import Modal from "Common/Components/Modal";
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useState, useEffect } from "react";
import { FileEdit, Plus } from "lucide-react";
import Select from "react-select";
import { useAppServices } from "hook/services";

interface propTypes {
  handleRefresh: any;
  toggle: any;
  show: boolean;
  editData: any;
}

const TagEditModal = ({
  handleRefresh,
  show,
  toggle,
  editData,
}: propTypes) => {
  const AppService = useAppServices();

  const handleSubmit = async (values: any) => {
    const payload = {
      ...values,
      _id: editData._id,
    };
    const { response, error } = await AppService.tag.update({
      payload,
      toaster: true,
    });
    if (response) {
      toggle();
      handleRefresh();
    }
  };

  // Formik + Yup
   const formik = useFormik({
     enableReinitialize: true,
     initialValues: {
       name: editData?.name || "",
     },
     validationSchema: Yup.object({
       name: Yup.string().required("Please enter field name"),
     }),
     onSubmit: (values) => handleSubmit(values),
   })


  return (
    <>
      <Modal
        show={show}
        onHide={toggle}
        id="tagModal"
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[40rem] bg-white shadow rounded-md dark:bg-zink-600"
      >
        <Modal.Header className="flex items-center justify-between p-4 border-b dark:border-zink-300/20">
          <Modal.Title className="text-16 font-semibold">
            Edit Tag
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          <form onSubmit={formik.handleSubmit} className="space-y-4">
            {/* Name */}
            <div>
              <label className="block mb-1 text-sm font-medium">Name</label>
              <input
                type="text"
                name="name"
                placeholder="Enter field name"
                className="form-input w-full"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.name}
              />
              {formik.touched.name && formik.errors.name && (
                <p className="text-red-400 text-sm mt-1">
                  {/* {formik.errors.name} */}
                </p>
              )}
            </div>


            {/* Actions */}
            <div className="flex justify-end gap-2 pt-2">
              <button
                type="button"
                className="text-red-500 bg-white border btn hover:text-red-600"
                onClick={() => {
                  formik.resetForm();
                  toggle();
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="text-white btn bg-custom-500 border-custom-500 hover:bg-custom-600"
              >
                Edit Tag
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default TagEditModal;
